export default __webpack_public_path__ + "static/media/orientation_video_CORE.9f43d822.png";